import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { createAppTheme } from "../theme";
const ThemeContext = createContext(undefined);
const THEME_STORAGE_KEY = "scout-theme-mode";
export const ThemeProvider = ({ children }) => {
    const [mode, setMode] = useState(() => {
        const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
        return savedTheme === "light" || savedTheme === "dark" ? savedTheme : "dark";
    });
    useEffect(() => {
        localStorage.setItem(THEME_STORAGE_KEY, mode);
    }, [mode]);
    const toggleTheme = () => {
        setMode((prevMode) => (prevMode === "dark" ? "light" : "dark"));
    };
    const setTheme = (newMode) => {
        setMode(newMode);
    };
    const theme = useMemo(() => createAppTheme(mode), [mode]);
    const contextValue = { mode, toggleTheme, setTheme };
    return (_jsx(ThemeContext.Provider, Object.assign({ value: contextValue }, { children: _jsxs(MuiThemeProvider, Object.assign({ theme: theme }, { children: [_jsx(CssBaseline, {}), children] })) })));
};
export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error("useTheme must be used within a ThemeProvider");
    }
    return context;
};
